import { useEffect, useState } from "react";
import { Button, Card, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../../common/Loader";
import NoData from "../../common/NoData";
import Pagination from "../../common/Pagination/Pagination";
import { Translate } from "../../Enums/Tranlate";
import CardItem from "./CardItem";
import LeaderShipService from "../../../services/LeaderShipService";
import OurBoardService from "../../../services/OurBoardService";

const Leadership = () => {
	const [admins, setAdmins] = useState(null);
	const [hasData, setHasData] = useState(null);
	const [selectTab, setSelectTab] = useState("leadership");
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();
	const Service =
		selectTab === "leadership"
			? new LeaderShipService()
			: new OurBoardService();
	const lang = useSelector((state) => state.auth?.lang);
	const location = useLocation();

	useEffect(() => {
		if (location?.state === "leadership" || location?.state === "ourboard") {
			setSelectTab(location?.state);
			setShouldUpdate((prev) => !prev);
		}
	}, [location]);

	return (
		<div className="admin">
			<div className="tabs-div mb-4">
				{["leadership", "ourboard"]?.map((tab, index) => {
					return (
						<p
							key={index}
							className={`${tab === selectTab ? "activeP" : ""}`}
							onClick={() => {
								setSelectTab(tab);
								setShouldUpdate((prev) => !prev);
							}}>
							{Translate[lang][tab]}
						</p>
					);
				})}
			</div>
			<div className="mb-3">
				<div className="d-flex justify-content-between align-items-center">
					<div>
						<span
							style={{
								fontWeight: "600",
								textTransform: "capitalize",
								color: "#000",
							}}>
							{Translate[lang][selectTab]}
						</span>
					</div>
					<div className="add-admin">
						<Button
							variant="primary"
							className="me-2 h-75"
							onClick={() => {
								navigate("/leadership-ourboard/add-leadership", {
									state: { type: selectTab },
								});
							}}>
							<i
								className={`la la-plus ${lang === "en" ? "mr-2" : "ml-2"}`}></i>
							{Translate[lang]?.add} {Translate[lang][selectTab]}
						</Button>
					</div>
				</div>
			</div>

			<div>
				<div className={`${hasData === 0 ? "text-center" : "table-style"}`}>
					{loading && (
						<div style={{ height: "300px" }}>
							<Loader />
						</div>
					)}
					{hasData === 1 && !loading && (
						<Table responsive>
							<thead>
								<tr>
									<th>
										<strong>{Translate[lang]?.name}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.job}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.image}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.action}</strong>
									</th>
								</tr>
							</thead>
							<tbody>
								{admins?.length > 0 &&
									admins?.map((item, index) => {
										return (
											<CardItem
												key={index}
												index={index}
												item={item}
												selectTab={selectTab}
												Service={Service}
												setShouldUpdate={setShouldUpdate}
											/>
										);
									})}
							</tbody>
						</Table>
					)}
					{hasData === 0 && <NoData />}
					<Pagination
						setData={setAdmins}
						service={Service}
						shouldUpdate={shouldUpdate}
						setHasData={setHasData}
						setLoading={setLoading}
					/>
				</div>
			</div>
		</div>
	);
};
export default Leadership;
